<template>
  <Layout>
    <div class="content is-size-7 p-md">
      <p class="is-size-5 has-text-white">
        {{ $t('Page visible only to registered users.') }}
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Profile',
  components: {
    Layout
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/Profile.vue